import { html } from 'lit';
import { fixture, expect } from '@open-wc/testing';
import sinon from 'sinon';
import { IxCard } from '../src/IxCard.js';
import '../src/ix-card.js';

describe('<ix-card>', () => {
  let element: IxCard;

  beforeEach(async () => {
    element = await fixture(html`<ix-card></ix-card>`);
  });

  afterEach(() => {
    sinon.reset();
  });

  it('renders with default properties', () => {
    expect(element.itemId).to.equal('');
    expect(element.name).to.equal('');
    expect(element.names).to.deep.equal([]);
    expect(element.isActive).to.be.false;
    expect(element.type).to.equal('roles');
  });

  it('applies active class when isActive is true', async () => {
    element.isActive = true;
    await element.updateComplete;
    const cardContainer = element.shadowRoot!.querySelector('div')!;
    expect(cardContainer.classList.contains('active')).to.be.true;
  });

  it('displays the correct card name when there is one name', async () => {
    element.names = ['Admin'];
    await element.updateComplete;
    const subText = element.shadowRoot!.querySelector('.card-sub-text')!;
    expect(subText.textContent!.trim()).to.equal('Admin');
  });

  it('displays the correct card name when there are multiple names', async () => {
    element.names = ['Admin', 'User'];
    await element.updateComplete;
    const subText = element.shadowRoot!.querySelector('.card-sub-text')!;
    expect(subText.textContent!.trim()).to.equal('2 roles');
  });

  it('dispatches ToggleCard event on click', async () => {
    const spy = sinon.spy();
    element.itemId = '123';
    element.addEventListener('toggle-card', spy);
    await element.updateComplete;

    const cardContainer = element.shadowRoot!.querySelector('div')!;
    cardContainer.click();
    await element.updateComplete;

    expect(spy.calledOnce).to.be.true;
    expect(spy.firstCall.args[0].detail).to.equal('123');
  });

  it('dispatches show-tooltip event on mouseover', async () => {
    const spy = sinon.spy();
    document.addEventListener('show-tooltip', spy);

    element.name = 'Test Tooltip';
    await element.updateComplete;

    const header = element.shadowRoot!.querySelector('.card-header')!;
    header.dispatchEvent(new MouseEvent('mouseover'));
    expect(spy.calledOnce).to.be.true;
    expect(spy.firstCall.args[0].detail.tooltip.values).to.include(
      'Test Tooltip',
    );
    document.removeEventListener('show-tooltip', spy);
  });

  it('dispatches hide-tooltip event on mouseout', async () => {
    const spy = sinon.spy();
    document.addEventListener('hide-tooltip', spy);
    await element.updateComplete;

    const header = element.shadowRoot!.querySelector('.card-header')!;
    header.dispatchEvent(new MouseEvent('mouseout'));

    expect(spy.calledOnce).to.be.true;
    expect(spy.firstCall.args[0].detail.target).to.equal(header);
    document.removeEventListener('hide-tooltip', spy);
  });

  it('does not render sub-text if type is not roles', async () => {
    element.type = 'flags';
    element.names = ['Feature 1', 'Feature 2'];
    await element.updateComplete;

    const subText = element.shadowRoot!.querySelector('.card-sub-text');
    expect(subText).to.be.null;
  });
});
